import { ClassValue } from 'clsx';
import { UseFormRegisterReturn } from 'react-hook-form';

import { cn } from '@/utils/styles';

import { colors, sizes } from './constants';
import { SelectColor, SelectSize } from './types';

export type SelectProps = {
  readonly options: { label: string; value: string }[];
  readonly id?: string;
  readonly size?: SelectSize;
  readonly color?: SelectColor;
  readonly placeholder?: string;
  readonly defaultValue?: string;
  readonly value?: string;
  readonly registration?: Partial<UseFormRegisterReturn>;
  readonly className?: ClassValue;
  readonly onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  readonly readOnly?: boolean;
};

export function Select({
  options,
  id,
  size = 'md',
  color = 'primary',
  placeholder,
  className,
  defaultValue,
  value,
  registration,
  readOnly = false,
}: SelectProps) {
  return (
    <select
      id={id}
      disabled={readOnly}
      className={cn(
        'group w-full transition',
        'text-base leading-6 text-neutral-900',
        'bg-white',
        sizes[size],
        'appearance-none rounded-sm border outline-none',
        'focus:outline-none',
        'focus:ring-2 focus:ring-offset-0',
        colors[color],
        'disabled:bg-neutral-25 disabled:text-neutral-disabled disabled:border-neutral-50',
        'disabled:pointer-events-none disabled:cursor-not-allowed',
        className
      )}
      value={value}
      defaultValue={value === undefined ? defaultValue : undefined}
      {...registration}
    >
      {placeholder ? (
        <option className="text-base leading-6 font-normal tracking-wide text-neutral-900" value="">
          {placeholder}
        </option>
      ) : null}

      {options.map(({ label, value }) => (
        <option
          key={value}
          value={value}
          className="border-red border-4 text-base leading-6 font-normal tracking-wide text-neutral-900"
        >
          {label}
        </option>
      ))}
    </select>
  );
}
